import Http from '../libs/http';
import morenImage from '../assets/imgs/moren.jpg';
import orderConstants from '../constants/order-constants';

// 下单中的service
export default {
  getProgress(applicant) {
    let totals = 0;
    let finished = 0;

    applicant.material.material_required.forEach((material) => {
      if (material.attr === 0) {
        totals++;

        if (material.pattern === 3 && applicant.marital_status > 0) {
          if (applicant.marital_status === 2 || applicant.marital_status === 3) {
            if (material.upload.length && material.upload[0].url) finished++;
          } else {
            finished++;
          }
          return;
        }

        if (material.pattern === 3 && applicant.marital_status > 0) {
          if (applicant.marital_status === 2 || applicant.marital_status === 3) {
            if (material.upload.length && material.upload[0].url) finished++;
          } else {
            finished++;
          }
          return;
        }

        // 护照和身份证需要单独处理，这两者必需要确认信息且保存后（elec_status 为 2）才算上传
        if (material.pattern === 1 || material.pattern === 2) {

          // 护照
          if (material.pattern === 2) {
            if (material.upload.length === 1) {
              if (material.upload[0].elec_status === 2 && material.upload[0].url) {
                finished++;
              }
            }
          }

          // 若是身份证，则要正反两面都上传才算完成
          if (material.pattern === 1) {
            if (material.upload.length === 1) {
              if (material.upload[0].elec_status === 2 && material.upload[0].special_code) {
                finished++;
              }
            } else if (material.upload.length === 2) {
              const isAllUploaded = material.upload.every(upload => upload.elec_status === 2 && upload.url);

              if (isAllUploaded) {
                finished++;
              }
            }
          }
        } else if (material.upload.length && material.upload.every(upload => upload.url || upload.special_code)) {
          finished++;
        }
      }
    });

    if (applicant.id_photo) {
      totals++;
      applicant.id_photo.dest_photo && (finished++);
    }

    return parseInt(finished / (totals || 1) * 100, 10);
  },

  makePreferredDate() {
    return [{ date: null, period: 0 }, { date: null, period: 0 }, { date: null, period: 0 }];
  },

  // (已确认)
  extractInterviewInfo(order) {
    const formData = {
      user_order_id: order.user_order_id,
      interview_together: order.interview_together,
    };
    const { applicant } = order;
    formData.data = applicant.map(({ interview, order_applicant_id, applicant_name }) => (interview ? {
      applicant_name,
      date_choice: interview.date_choice,
      other_date: interview.other_date,
      preferred_date: interview.date_choice === 0 ? interview.preferred_date : this.makePreferredDate(),
      order_applicant_id,
      embassy_district_id: interview.embassy_district_id || undefined,
    } : {
      date_choice: 0,
      other_date: '',
      preferred_date: this.makePreferredDate(),
      order_applicant_id,
    }));
    return formData;
  },

  /**
   * 获取订单步骤
   * @param {Object} order 订单
   */
  getOrderSteps(order) {
    const steps = [{
      name: order.offline === 1 ? '生成订单' : '资料上传', // 向上订单和线下订单区别
      active: order.order_status === orderConstants.STATUS.waittingToUploadMaterial_1 || order.order_status === orderConstants.STATUS.waittingToWriteApplicantion_2,
      orderStatus: 1,
      className: 'upload',
      disabled: [1, 2].indexOf(order.order_status) > -1 ? 1 : 0,
      routeConfig: {
        name: 'waittingForUpload',
        params: {
          oid: order.user_order_id,
        },
      },
    }];
    if (order.offline === 1) {
      steps[0].disabled = 1;
    }


    // 需要面试或者面递,不管陪签不陪签
    if (order.need_interview > 0 || order.need_delivery > 0) {
      steps.push({
        name: '赴馆日期',
        active: order.order_status === orderConstants.STATUS.waittingToSelectGoToEmbassyTime_10,
        orderStatus: 10,
        className: 'interview',
        disabled: [1, 2].indexOf(order.order_status) > -1 ? 1 : 0,
        routeConfig: {
          name: 'waittingForChooseInterviewTime',
          params: {
            oid: order.user_order_id,
          },
        },
      });
    }

    // 一定都有确认订单
    steps.push({
      name: '确认订单',
      active: order.order_status > 2 && order.order_status !== orderConstants.STATUS.waittingToSelectGoToEmbassyTime_10,
      orderStatus: 2.5, // 2.5 其实就是确认订单状态, 因为后端没有确认订单中这个状态
      disabled: [1, 2, 10].indexOf(order.order_status) > -1 ? 1 : 0,
      className: 'confirm',
      routeConfig: {
        name: 'orderComfirm',
        params: {
          oid: order.user_order_id,
        },
      },
    });

    return steps;
  },

  /**
   * 获取订单信息
   * @param {Number} orderId 订单号
   * @return {Promise}
   */
  getOrderData(orderId) {
    return Http.post('/order_query', { user_order_id: orderId });
  },


  // 获取拒签详情
  getApplicantRejectVisaDetail(data) {
    return Http.post('/applicant_reject_query', data);
  },

  /**
   * 获取商品信息
   * @param {Number} visaProductId 商品 ID
   * @return {Promise}
   */
  getProductData(visaProductId) {
    return Http.post('/visa_product_query', {
      visa_product_id: visaProductId,
    });
  },

  updateOrderDepartDate(order) {
    return Http.post('/order_depart_date_update', { user_order_id: order.user_order_id, depart_date: order.depart_date });
  },

  /**
   * 订单添加申请人
   * @param
   * @return {Promise}
   */
  orderAddApplicant(param) {
    return Http.post('/applicant_add', param);
  },

  /**
   * 飞猪订单添加申请人
   * @param
   * @return {Promise}
   */
  fliggyOrderAddApplicant(param) {
    return Http.post('/ota_applicant_add', param);
  },

  /**
   * 获取最早赴馆日期信息
   * @param {user_order_id} orderId 订单号
   * @return {Promise}
   */
  getEarlistDateData(orderId) {
    return Http.post('/order_appointment_earliest_date_get', { user_order_id: orderId });
  },

  /**
   * 上传完成检查
   * @param {Number} orderId 订单编号
   */
  uploadCheck(orderId) {
    return Http.post('/order_upload_check', { user_order_id: orderId });
  },

  /**
   * 申请表检查
   * @param {Number} orderId 订单号
   */
  applicationCheck(orderId) {
    return Http.post('/order_application_check', { user_order_id: orderId });
  },

  /**
   * 查询国家假期
   * @param {Number} visaCountryId 国家编号
   */
  countryHolidayQuery(visaCountryId) {
    return Http.post('/sys/visa_country_holiday_date_query', {
      visa_country_id: visaCountryId,
    });
  },

  /**
   * 获取申请人头像样式对象
   * @param {Object} applicant 申请人
   */
  getApplicantAvatarStyle(applicant) {
    return { backgroundImage: `url(${applicant.id_photo && applicant.id_photo.dest_photo ? applicant.id_photo.dest_photo : morenImage})` };
  },

  /**
   * 删除申请人列表
   * @param {Number} orderId 订单号
   * @return {Promise}
   */
  deleteApplicant(order_applicant_id, user_order_id) {
    return Http.post('/applicant_delete', { user_order_id, applicant_id_set: [order_applicant_id] });
  },
  /**
   * 检测两个日期（出行日期和护照有效期）差距是否在几个月内（6或9）
   * @param {String} departDate yyyy-mm-dd  出行日期
   * @param {String} expireDate yyyy-mm-dd  护照有效日期
   * @param {Number} limit 月数
   * @return {Boolean}
   */
  withinDate(departDate, expireDate, limit) {
    const [dy, dm, dd] = departDate.split('-').map(item => parseInt(item, 10));
    const [ey, em, ed] = expireDate.split('-').map(item => parseInt(item, 10));
    if (ey - dy > 1) {
      return false;
    }
    if (ey - dy < 0) {
      return true;
    }
    let gapMonths = 0;
    if (ey > dy) {
      gapMonths = 12 + em - dm;
    }
    if (ey === dy) {
      gapMonths = em - dm;
    }
    if (ed < dd) {
      gapMonths--;
    }
    return gapMonths < limit;
  },
  /**
   * 查询该商品的线上递交的必填资料中包含【邮寄资料】（不包括赴馆）
   * @param {Object} product 商品
   */
  isIncludePaperMaterialByRequiredMaterial(product) {
    if (!product || !product.material || !product.material.length) return false;
    // 如果不支持【线下办理】则返回false
    if (product.offline !== 1) return false;
    
    // 所有身份的必填资料合并
    const allRequiredMaterialList = [];
    product.material.forEach((it) => {
      allRequiredMaterialList.push(...(it.material_required || []));
    });

    return !!allRequiredMaterialList.find(material => material.attr === 1);
  },

};



// WEBPACK FOOTER //
// ./src/services/ordering-service.js